import { QuotaUsage } from "#features/quotas/components/QuotaUsage.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Div, Flex, Link } from "@hopper-ui/components";

export const Footer = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex
            direction="column"
            gap="inline-md"
            width="100%"
            justifyContent="center"
            alignItems="center"
            paddingY="inset-md"
        >
            <QuotaUsage />
            <Div
                textAlign="center"
                color="neutral-weak"
                fontSize="body-xs"
                UNSAFE_paddingX={{ base: "3rem", md: "0" }}
            >
                {tShared("footerNote")}
                <Link
                    variant="secondary"
                    href={tShared("learnMoreLink")}
                    isExternal
                    isQuiet
                >
                    {tShared("learnMore")}
                </Link>
            </Div>
        </Flex>
    );
};
